import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'poblacion/pdf';
const CONTEXT_BASE_HTML_PATH = 'poblacion/html';
const CONTEXT_SINGLE_BASE_PATH = 'poblacion/pdfindividual';
// #endregion

// #region Public functions
async function getTownPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchTownPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchTownHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getTownPdf,
  searchTownPdf,
  searchTownHtml,
};
